import { render, staticRenderFns } from "./AppBody.vue?vue&type=template&id=30082486&scoped=true&"
import script from "./AppBody.vue?vue&type=script&lang=js&"
export * from "./AppBody.vue?vue&type=script&lang=js&"
import style0 from "./AppBody.vue?vue&type=style&index=0&id=30082486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30082486",
  null
  
)

export default component.exports